<template>
    <div>
        <div class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center profile-header" style="min-height: 200px;">
            <b-container fluid>
                <span class="mask bg-gradient-success opacity-8"></span>
            </b-container>
        </div>
        <b-container v-if="isLoading" fluid class="mt--7">
            <card><p>Loading...</p></card>
        </b-container>
        <b-container v-else fluid class="mt--7">
            <card>
                <div class="d-flex flex-row-reverse">
                    <button v-if="jobGroup.id!==null" class="btn btn-success" @click="runJobGroup()">Run</button>
                    <button class="btn btn-success" @click="saveJobGroup()">{{jobGroup.id!==null ? 'Save' : 'Create'}}</button>
                </div>
                <b-row>
                    <b-col>
                        <base-input label="ID" placeholder="ID" :readonly="true" v-model="jobGroup.id" />
                    </b-col>
                    <b-col>
                        <base-input label="Name" placeholder="Name" v-model="jobGroup.name" />
                    </b-col>
                </b-row>
            </card>
            <card>
                <b-row>
                    <h4>Domain jobs:</h4>
                </b-row>
                <b-row>
                    <div class="badge badge-primary d-inline-flex align-items-center mr-1" v-for="(jobData,index) in jobGroup.jobs" :key="index+'jobgroupjob'">
                        <router-link v-bind:key="index+'_jobgroupjob_router'" :to="'/domain/'+jobData.domain.id">
                            {{jobData.domain.name}}
                        </router-link>
                        <span class="closebtn" @click="removeFromJobList(index)">&times;</span>
                    </div>
                </b-row>
            </card>
            <card>
                <base-input label="Name" placeholder="Name" v-model="tableFilters.domain__name__icontains"/>
                <h4 v-if="tableLoading">Loading...</h4>
                <template v-else>
                    
                    <el-table class="table-responsive table"
                            header-row-class-name="thead-light"
                            :data="tableData">
                        <el-table-column label="Name" prop="domain.name" />
                        <el-table-column label="Add to job group" prop="_">
                            <template v-slot="{row}">
                                <b-media no-body class="align-items-center justify-content-end">
                                    <base-button icon type="info" @click="switchInJobList(row)">
                                        <span class="btn-inner--icon">
                                            <i :class="{'ni ni-check-bold':selectedIds.includes(row.id), 'ni ni-fat-add':!(selectedIds.includes(row.id))}"/>
                                        </span>
                                    </base-button>
                                </b-media>
                            </template>
                        </el-table-column>
                    </el-table>

                    <b-card-footer class="py-4 d-flex justify-content-end">
                        <base-pagination v-model="currentPage" :per-page="10" :total="total" @change="pageChanged">
                            <template v-slot:prev-text>
                                <a class="page-link" aria-label="Previous">
                                    <span aria-hidden="true"><i class="fa fa-angle-left" aria-hidden="true"></i></span>
                                </a>
                            </template>
                        </base-pagination>
                    </b-card-footer>
                </template>
            </card>
        </b-container>
    </div>
</template>

<script>
import {Table,TableColumn} from 'element-ui'

import RepositoryFactory from "@/repositories/RepositoryFactory"

const JobRepository = RepositoryFactory.get('job');
const JobGroupRepository = RepositoryFactory.get('job_group');

export default {
    props:{
        id:String,
    },
    components:{
        [Table.name]:Table,
        [TableColumn.name]:TableColumn,
    },
    watch:{
        tableFilters:{
            handler(oldVal,newVal){
                clearTimeout(this.tableFilterTimer);
                this.tableLoading=true;
                for(var i in this.tableFilters){
                    if(this.tableFilters[i]==="")
                        delete this.tableFilters[i]
                    }
                this.tableFilterTimer=setTimeout(() => this.filterTable(), 1000);
            },
            deep:true,
        }
    },
    data(){
        return {
            isLoading:true,
            jobGroup:null,

            selectedIds:[],

            tableFilters:{},
            tableFilterTimer:undefined,
            tableData:[],
            currentPage:1,
            total:0,
            tableLoading:true,
        }
    },
    created(){
        if(this.id==="new"){
            this.jobGroup={
                id:null,
                name:null,
                jobs:[],
            }
            this.isLoading=false;
        }
        else{
            JobGroupRepository.get(this.id).then((response) => {
                this.jobGroup=response.data[0];
                for(var i in this.jobGroup.jobs){
                    this.selectedIds.push(this.jobGroup.jobs[i].id);
                }
                this.isLoading=false;
            });
        }
        
        this.getTable(1,this.tableFilters);
    },
    methods:{
        addToJobList(data){
            this.jobGroup.jobs.push(data);
            this.selectedIds.push(data.id);

            this.$forceUpdate();
        },
        removeFromJobList(index){
            var id_index=this.selectedIds.indexOf(this.jobGroup.jobs[index].id);
            this.jobGroup.jobs.splice(index,1);
            this.selectedIds.splice(id_index,1);

            this.$forceUpdate();
        },
        switchInJobList(data){
            if(this.selectedIds.includes(data.id)){
                for(var i in this.jobGroup.jobs){
                    var job=this.jobGroup.jobs[i];
                    if(job.id===data.id){
                        this.removeFromJobList(i);
                        break;
                    }
                }
            }
            else{
                this.addToJobList(data)
            }
        },
        getTable(pageNumber,filters){
            this.currentPage=pageNumber;
            this.tableLoading=true;
            JobRepository.idNameTable(this.currentPage,filters).then((response) => {
                var data=response.data;
                this.total=data.count;
                this.tableData=data.results;
                this.$forceUpdate();
                this.tableLoading=false;
            })
        },
        pageChanged(pageNumber){
            this.getTable(pageNumber,this.tableFilters);
        },
        filterTable(){
            this.getTable(1,this.tableFilters)
        },
        saveJobGroup(){
            var id=this.jobGroup.id;
            var payload={
                name:this.jobGroup.name,
                jobs:[],
            }

            for(var i in this.jobGroup.jobs){
                payload.jobs.push(this.jobGroup.jobs[i].id);
            }
            if(id!==null){ // Güncelle
                JobGroupRepository.put(id,payload).then((response) => {
                    this.$notify({
                        message: 'Job group saved: '+this.jobGroup.name,
                        type: 'info',
                        size: 'lg',
                        timeout: 5000,
                        showClose: true
                    });
                })
            }
            else { // Oluştur
                JobGroupRepository.post(payload).then((response) => {
                    this.jobGroup.id=response.data.id;
                    this.$router.push({name:'job group',params:{id:this.jobGroup.id}});
                })
            }
            
        },
        runJobGroup(){
            if(this.jobGroup.id===null || this.jobGroup.id===undefined)
                return;
            
            JobGroupRepository.runJobGroup(this.jobGroup.id).then((response) => {
                this.$notify({
                message: 'Job group started successfully',
                type: 'success', // success, warning, error
                size: 'lg', // or 'sm'
                timeout: 5000,
                showClose: true
                })
            })
        }  
    }
}
</script>

<style>

</style>